export default __webpack_public_path__ + "static/media/switch-app-ill.250b94f2.svg";